import {afterNextRender, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {Subscription} from "rxjs";
import {MatDialog} from "@angular/material/dialog";
import {DialogModule} from "@angular/cdk/dialog";
import {NgClass, NgIf} from "@angular/common";

//Components
import {CityDropDownComponent} from "./top-navbar/city-drop-down/city-drop-down.component";
import {DeliveryAddressComponent} from "./delivery-address/delivery-address.component";
import {StarRatingComponent} from "../../../modules/user/star-rating/star-rating.component";
import {MenuCatalogComponent} from "./menu-catalog/menu-catalog.component";
import {DeliveryDateComponent} from "./delivery-date/delivery-date.component";
import {FavoriteAddressComponent} from "./favorite-address/favorite-address.component";
import {SearchDialogComponent} from "../search-dialog/search-dialog.component";

//Services
import {RequestMethodsService} from "@services/request/request-methods.service";
import {GlobalSubscriptionService} from "@services/subscriptions/global-subscription.service";
import {CityService} from "@services/city/city.service";
import {ComponentService} from "@services/components/component.service";
import {BrowserService} from "@services/components/browser.service";
import {BottomSheetDialogService} from "@services/bottom-sheet-dialog/bottom-sheet-dialog.service";
import {AuthService} from "@services/auth/auth.service";
import {BasketService} from "@services/basket/basket.service";
import {ConfirmationDialogService} from "@services/confirmation-dilog/confirmation-dilog.service";
import {IsInGeofenceService} from "@services/is-in-geofence/is-in-geofence.service";

//Constants
import {CityInterface} from "@interfaces/components/cities.interface";
import {UpdateSubscriptionTypesEnum} from "@interfaces/orders/enums/update-subscription-types.enum";
import {FavoriteAddressInterface} from "@interfaces/orders/favorite-address.interface";
import {ConfirmationActionEnum} from "@interfaces/components/enums/confirmation-action.enum";
import {EndpointConstant} from "@interfaces/global/endpoint.constant";
import {OrderRateInterface} from "@interfaces/components/star-rating.interface";
import {TranslateModule} from "@ngx-translate/core";
import {UsersInterface} from "@interfaces/components/users.interface";
import {OrderInfoInterface} from "@interfaces/orders/order-info.interface";
import {CheckToken} from "@interfaces/auth/login.interface";
import {BonusInfoDialogComponent} from "../../shared-modules/global/bonus-info-dialog/bonus-info-dialog.component";
import { SelectionInterface } from '@interfaces/components/selection.inteface';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: true,
  providers: [ComponentService],
  imports: [ DialogModule, NgClass, NgIf, SearchDialogComponent, TranslateModule, MenuCatalogComponent, RouterLink, FavoriteAddressComponent, DeliveryDateComponent]
})
export class NavbarComponent {
  @ViewChild('searchMenu') searchMenu!: ElementRef;
  @Input() scrolled!: boolean;
  cities!: Array<CityInterface>;
  cityControl!: { address: FavoriteAddressInterface } | { city: CityInterface };
  subscription!: Subscription;
  defaultAddressIsSelected = false;
  openComponentForMobileMap = false;
  searchBy = '';
  catlog = false;
  isTablet: boolean | null = null;
  isMobile: boolean | null = null;
  bonusAmount = 0;
  selectedAddressName!: string;
  favoriteAddress!: Array<FavoriteAddressInterface>;
  userInfo!:UsersInterface | null;
  promoCode!: string | null;
  deliverOn!: string | null;
  availableSlots = [

  ]
  selection!: SelectionInterface;
  favoriteValue = false;

  constructor(
    protected requestService: RequestMethodsService,
    protected globalSubscriptionService: GlobalSubscriptionService,
    protected cityService: CityService,
    protected activatedRoute: ActivatedRoute,
    protected componentService: ComponentService,
    protected browserService: BrowserService,
    protected dialog: MatDialog,
    protected bottomSheetService: BottomSheetDialogService,
    protected authService: AuthService,
    protected router: Router,
    protected basketService: BasketService,
    protected confirmationDialogService: ConfirmationDialogService,
    protected mapService: IsInGeofenceService
  ) {
    afterNextRender(() => {
      this.checkUserOrderForRating();
      this.detectCurrentCityOrAddress();
      this.isTablet = this.browserService.isTabletDevice;
      this.isMobile = this.browserService.isMobileDevice;
      this.globalSubscriptionService.getMessage().subscribe((data: { type: string, message: any }) => {
        if (data.type === UpdateSubscriptionTypesEnum.MOBILE_MAP_EMIT) {
          if (data.message) {
            this.onSelectChange({address: data.message})
          }
        } else if (data.type === UpdateSubscriptionTypesEnum.OPEN_ADDRESS_SELECTION) {
          this.openMapOrFavoriteAddressDialog();
        } else if (data.type === UpdateSubscriptionTypesEnum.NAVBAR_DATA && data.message?.product) {
          this.favoriteValue = data.message?.product.liked || false;
        }
      })
      const userInfo = this.authService.getUserInfo();

      this.userInfo = userInfo;

      if (!userInfo || !userInfo.bonusAmount) {
        return;
      }
      this.getAvailableSelection();
      this.getFavoriteAddress();
      this.bonusAmount = userInfo.bonusAmount;
    })
  }

  getAvailableSelection(): void {
    this.requestService.get('user/selections/top').subscribe((data: SelectionInterface) => {
        this.selection = data;
    })
  }

  detectCurrentCityOrAddress(): void {
    const data = this.cityService.getCityIdFromLocalStorage();
    if (data) {
      this.cityControl = data;
    } else {
      this.cityControl = this.cityService.getDefaultAddress();
      this.defaultAddressIsSelected = true;
      this.updateAddressOrCityInLocalStorageAndMakeEmitToUpdate(this.cityControl, false)
    }
    this.selectedAddressName = 'address' in this.cityControl ? this.cityControl.address?.fullAddress : this.cityControl.city?.name
  }

  openBonusDialog(): void {
   this.dialog.open(BonusInfoDialogComponent, {
      width: '512px',
      height: 'auto',
      data: this.authService.getUserInfo()
    });
  }

  openDialogOrBottomSheetAddressSelect(openSelectionDialog: boolean): void {
    this.defaultAddressIsSelected = false;
    if (openSelectionDialog) {
      this.openAsDialogForSelectAddress()
    }
  }

  openAsDialogForSelectAddress(): void {
    const dialogRef = this.dialog.open(DeliveryAddressComponent, {
      panelClass: this.isMobile ? '' : 'class_for_close_button',
      data: {
        selectedAddress: this.cityControl && 'address' in this.cityControl ? this.cityControl.address : null,
      },
      disableClose: !this.cityService.getCityIdFromLocalStorage()
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data && 'city' in data) {
        this.onSelectChange({city: data.city})
      } else if (data) {
        this.onSelectChange({address: data.address})
      }
    })
  }

  openMapOrFavoriteAddressDialog(): void {
    if (!this.favoriteAddress?.length) {
      this.openAsDialogForSelectAddress();
      return
    }

    if (!this.userInfo || !this.favoriteAddress?.length) {
      this.openAsDialogForSelectAddress()
    } else {
      this.openFavoriteAddressDialog()
    }
  }

  openDeliveryDateDialog(): void {
    if (!this.isTablet) {return}
    const dialogRef = this.dialog.open(DeliveryDateComponent, {
      panelClass: 'class_for_close_button',
      data: {slots: this.availableSlots, deliverOn: this.deliverOn},
    })

  }

  openFavoriteAddressDialog(): void {
    const dialogRef = this.dialog.open(FavoriteAddressComponent, {
      panelClass: 'class_for_close_button',
    })

    dialogRef.afterClosed().subscribe(res => {
      if (res && res.selectedAddress) {
        this.onSelectChange({address: res.selectedAddress});
      } else if (res && res === 'ADD_NEW_ADDRESS') {
        this.openAsDialogForSelectAddress()
      }
      this.getFavoriteAddress();
    })

  }

  getFavoriteAddress(): void {
    this.requestService.get(`${EndpointConstant.favorite}-${EndpointConstant.addresses}`)
      .subscribe((response: Array<FavoriteAddressInterface>) => {
        this.favoriteAddress = response;
      })
  }

  closeMobileMap(address: FavoriteAddressInterface): void {
    this.openComponentForMobileMap = false;
    this.updateAddressOrCityInLocalStorageAndMakeEmitToUpdate({address: address}, true)
  }

  openSignInDialog(): void {
    if (this.authService.checkTokenAndRedirectToAuth()) {
      return;
    }
  }

  navigateTo(url: string): void {
    const isUser = (this.authService.checkToken() === CheckToken.VALID);
    if (this.catlog) {
      this.catlog = false;
    }

    if (isUser || url === '/') {
      this.router.navigate([url]);
    } else {
      this.openSignInDialog();
    }
  }

  searchFor(value: string): void {
    this.searchBy = value;
  }

  onSelectChange(city: { address: FavoriteAddressInterface } | { city: CityInterface }): void {
    if (this.authService.checkToken()) {
      this.userModeCheckAvailability(city)
    } else {
      this.updateAddressOrCityInLocalStorageAndMakeEmitToUpdate(city);
    }
  }

  userModeCheckAvailability(city: { address: FavoriteAddressInterface } | { city: CityInterface }): void {
    this.basketService.checkBasketAvailabilityForNewAddress(city).subscribe((response: boolean) => {
      if (response) {
        this.updateAddressOrCityInLocalStorageAndMakeEmitToUpdate(city);
      } else {
        this.clearBasketForShop(city)
      }
    })
  }

  clearBasketForShop(city: { address: FavoriteAddressInterface } | { city: CityInterface }): void {
    this.confirmationDialogService.openConfirmationDialog(
      {
        title: 'notification.clear_bucket',
        content: 'notification.change_address_clear_all',
        firstButton: 'notification.back',
        secondButton: 'notification.clear',
      }).afterClosed().subscribe((res: ConfirmationActionEnum) => {
      if (res === ConfirmationActionEnum.APPROVE || !res) {
        return;
      }
      this.basketService.clearBasket().subscribe(() => {
        this.updateAddressOrCityInLocalStorageAndMakeEmitToUpdate(city);
      });
    })
  }

  updateAddressOrCityInLocalStorageAndMakeEmitToUpdate(
    city: { address: FavoriteAddressInterface } | { city: CityInterface },
    navigation = true
  ): void {
    this.cityControl = city;
    if ('address' in this.cityControl && !this.cityControl.address.cityName) {
      this.mapService.getCityName(this.cityControl.address.latitude, this.cityControl.address.longitude).subscribe(cityName => {
        if ('address' in this.cityControl) {
          this.cityControl.address.cityName = cityName;
          this.cityService.setCityId(this.cityControl);
        }
      })
    } else {
      this.cityService.setCityId(this.cityControl);
    }

    if (navigation) {
      setTimeout(() => {
        window.location.href = '/';
      }, 300)
    }
    this.selectedAddressName = 'address' in city ? city.address.fullAddress : city.city.name
  }

  checkUserOrderForRating(): void {
    if (!this.authService.checkToken()) {
      return;
    }

    this.requestService.get(`${EndpointConstant.orders}/${EndpointConstant.rate}/${EndpointConstant.all}`)
      .subscribe((arrayOfRates: Array<OrderRateInterface>) => {
        if (!arrayOfRates.length) {
          return;
        }
        this.openStarRatingComponent(arrayOfRates[0].id)
      })
  }

  openStarRatingComponent(orderId: number): void {
    const starRateDialog = this.dialog.open(StarRatingComponent, {
        width: this.browserService.isMobileDevice ? '330px' : '512px',
        height: 'auto',
        data: {orderId}
      }
    );
    starRateDialog.afterClosed().subscribe((res: any) => {
      if (res) {
        return;
      }
      this.skipOrderRate(orderId);
    })
  }

  skipOrderRate(orderId: number): void {
    this.requestService.put(`${EndpointConstant.orders}/${EndpointConstant.rate}/${orderId}/${EndpointConstant.skip}`, {})
      .subscribe(() => {
      })
  }

}
